import { Component, OnInit } from '@angular/core';
import { VariablesService, UtilService } from '../../../shared/services';

@Component({
  selector: 'app-update-banner',
  templateUrl: './update-banner.component.html',
  styleUrls: ['./update-banner.component.scss']
})
export class UpdateBannerComponent implements OnInit {

  constructor(
    public vars: VariablesService,
    public util: UtilService
  ) { }

  ngOnInit() {
  }


  getTheaterImage() {
    if (this.vars.fundraiser) {
      if (this.vars.fundraiser.theater) {
        return this.vars.fundraiser.theater.cdn_path;
      } else {
        return this.vars.fundraiser.leaderboard ? this.vars.fundraiser.leaderboard.cdn_path : '';
      }
    }
  }

}
